// extracted by mini-css-extract-plugin
export default {"container":"infoBar_container__AQPjx","infoContainer":"infoBar_infoContainer__Bxs0F","tutorialButton":"infoBar_tutorialButton__oWwrs"};